import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlagIcon from "vue-flag-icon";
import axios from "axios";
import store from "./store";
import i18n from "@/plugins/i18n";
import Swal from "sweetalert2";
import VueCookies from "vue-cookies";

Vue.prototype.$http = axios;
axios.defaults.headers.common["Content-Type"] = "application/json";

const token = localStorage.getItem("Token");
const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
if (token && isLoggedIn) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

let tokenHandled = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const msg = error?.response?.data?.message || error.message || "";

    const isExpired =
      status === 401 ||
      msg.includes("Token หมดอายุ") ||
      msg.includes("Your session has expired");

    if (isExpired && !tokenHandled) {
      tokenHandled = true;

      setTimeout(() => (tokenHandled = false), 2000);

      handleTokenExpired(msg);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

let isLoggingOut = false;
function handleTokenExpired(message) {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    document.querySelectorAll(".v-dialog__content").forEach((x) => x.remove());
    document.querySelectorAll(".v-overlay__scrim").forEach((x) => x.remove());
    document.body.classList.remove("overflow-y-hidden");
  } catch {
    console.warn("Token expired");
  }

  store.commit("logout");
  Vue.$cookies.keys().forEach((k) => Vue.$cookies.remove(k));
  localStorage.clear();
  delete axios.defaults.headers.common["Authorization"];

  Swal.fire({
    title: "Session Expired",
    text: message || "กรุณาเข้าสู่ระบบใหม่",
    icon: "warning",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
  }).then(() => {
    const current = router.currentRoute.fullPath;

    if (current !== "/Login") {
      router.replace("/Login").catch(() => {
        window.location.href = "/Login";
      });
    }

    isLoggingOut = false;
  });
}

function startTokenWatcher() {
  setInterval(() => {
    const token = localStorage.getItem("Token");
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload.exp * 1000;
      const now = Date.now();

      if (exp <= now) {
        console.warn(
          "⏰ Token expired (client-detected), triggering logout immediately"
        );
        store.dispatch(
          "ForceLogout",
          "Token ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่"
        );
      }
    } catch (e) {
      console.error("Token decode error:", e);
    }
  }, 10000); // ทุก 30 วินาที
}

startTokenWatcher();

window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false;
Vue.use(FlagIcon);
Vue.use(VueCookies);
new Vue({
  i18n,
  vuetify,
  store,
  router,
  Swal,
  render: (h) => h(App),
}).$mount("#app");
